<template>
  <div>
    <p>
      Вам предстоит пройти тест:
    </p>
    <p style="font-weight:bold">
      {{testLabel}}
    </p>
    <span v-if="showDescription">
      <p>
        Описание теста:
      </p>
      <p style="font-weight:bold">
        {{testDescription}}
      </p>
    </span>
    <p>
      На выполнение дано:
    </p>
    <p style="font-weight:bold">
      {{testTime}} мин.
    </p>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
      name: 'testwelcome',
      data() {
        return {

        }
      },
      computed: {
        showDescription: function() {
          if(this.testDescription)
            return true;
          return false;
        },
        ...mapGetters([
          'testLabel',
          'testDescription',
          'testTime',
          'isContestAuthorized'
        ])
      },
      methods: {
        ...mapActions([
          'initializeTest',
          'exit'
        ])
      },
      created: function() {
        if(!this.isContestAuthorized)
          this.$router.push(config.WELCOME_URL);
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contest/testwelcome.vue